(function () {
  'use strict';

  function setSelectedVariant(card, button) {
    var buttons = card.querySelectorAll('.js-grid-variant-button');
    buttons.forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var variantInput = card.querySelector('.js-grid-variant-id');
    if (variantInput) variantInput.value = button.dataset.variantId;

    var price = card.querySelector('.js-grid-current-price');
    var compare = card.querySelector('.js-grid-compare-price');
    var saving = card.querySelector('.js-grid-saving');
    var regularLabel = card.querySelector('.js-grid-regular-label');
    var saleLabel = card.querySelector('.js-grid-sale-label');

    if (price) price.textContent = button.dataset.price || '';

    var hasCompare = Boolean(button.dataset.comparePrice);
    if (compare) {
      compare.textContent = button.dataset.comparePrice || '';
      compare.hidden = !hasCompare;
    }
    if (regularLabel) regularLabel.hidden = !hasCompare;
    if (saleLabel) saleLabel.hidden = !hasCompare;

    if (saving) {
      var savingValue = button.dataset.saving || '';
      saving.textContent = savingValue ? 'Save ' + savingValue : '';
      saving.hidden = !savingValue;
    }
  }

  function syncCard(card) {
    if (!card || card.dataset.variantPriceSynced === 'true') return;

    var button = card.querySelector(
      '.js-grid-variant-button.is-selected, .js-grid-variant-button[aria-pressed="true"]'
    );
    if (!button || button.disabled) return;

    setSelectedVariant(card, button);
    card.dataset.variantPriceSynced = 'true';
  }

  function syncCards(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('.grid-product')) {
      syncCard(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.grid-product').forEach(syncCard);
    }
  }

  function observeDynamicProductSections() {
    document.querySelectorAll(
      '[data-section-type="product-recommendations"], [data-section-type="recently-viewed"]'
    ).forEach(function (section) {
      if (section.dataset.variantPriceObserver === 'true') return;
      section.dataset.variantPriceObserver = 'true';

      syncCards(section);

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            syncCards(node);
          });
        });
      });

      observer.observe(section, { childList: true, subtree: true });
    });
  }

  function initialize() {
    // Static collection/search/home product cards now render the correct selected
    // Wholesale Hub price directly in Liquid. Only dynamic product sections need
    // a JS synchronization pass when their cards are inserted after page load.
    observeDynamicProductSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize();
    }, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function () {
    initialize();
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-grid-variant-button');
    if (!button || button.disabled) return;

    var card = button.closest('.grid-product');
    if (!card) return;
    setSelectedVariant(card, button);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.js-grid-variant-form');
    if (!form) return;

    event.preventDefault();
    var submitButton = form.querySelector('.js-grid-add-to-cart');
    var message = form.querySelector('.js-grid-variant-message');
    if (!submitButton || submitButton.disabled) return;

    submitButton.disabled = true;
    submitButton.classList.add('btn--loading');
    if (message) message.textContent = '';

    fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status === 422) throw data;
          return data;
        });
      })
      .then(function (product) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: product, addToCartBtn: submitButton }
        }));
        if (message) message.textContent = 'Added to cart';
      })
      .catch(function (error) {
        if (message) message.textContent = error.description || 'Unable to add this item. Please try again.';
      })
      .finally(function () {
        submitButton.disabled = false;
        submitButton.classList.remove('btn--loading');
      });
  });
})();

/*
 * KimiKim x STOQ collection-card integration
 * Keeps STOQ's native notification workflow, but prevents the app's raw
 * collection button from flashing before our final placement is ready.
 */
(function () {
  'use strict';

  var OBSERVER_FLAG = 'kimiStoqCollectionObserver';

  function setNotifyText(button) {
    if (!button) return;

    if (button.tagName === 'INPUT') {
      button.value = 'Notify Me';
      return;
    }

    if (button.textContent.trim() !== 'Notify Me') {
      button.textContent = 'Notify Me';
    }
  }

  function placeStoqButton(card) {
    if (!card || !card.querySelector) return;
    if (!card.querySelector('.grid-product__tag--sold-out')) return;

    var button = card.querySelector('.restock-rocket-button-collection');
    var price = card.querySelector('.grid-product__price');
    if (!button || !price) return;

    var container = button.closest('.restock-rocket-button-container') || button.parentElement;
    if (!container) return;

    // Prepare the hidden STOQ button completely before the reveal class is added.
    setNotifyText(button);

    var oldForm = card.querySelector('.js-grid-variant-form');
    if (oldForm) oldForm.hidden = true;

    if (price.nextElementSibling !== container) {
      price.insertAdjacentElement('afterend', container);
    }

    container.classList.add('kimi-stoq-grid-container');
    button.classList.add(
      'btn',
      'btn--secondary',
      'btn--small',
      'grid-product__add-to-cart',
      'kimi-stoq-grid-button'
    );
  }

  function scan(root) {
    var scope = root || document;
    var cards = [];

    if (scope.matches && scope.matches('.grid-product')) {
      cards.push(scope);
    } else if (scope.closest) {
      var parentCard = scope.closest('.grid-product');
      if (parentCard) cards.push(parentCard);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.grid-product').forEach(function (card) {
        if (cards.indexOf(card) === -1) cards.push(card);
      });
    }

    cards.forEach(placeStoqButton);
  }

  function initializeStoqCollectionButtons() {
    scan(document);

    if (!document.body || document.body.dataset[OBSERVER_FLAG] === 'true') return;
    document.body.dataset[OBSERVER_FLAG] = 'true';

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // This file is loaded with defer, so the parsed body is available here.
  // Start watching immediately instead of waiting for DOMContentLoaded.
  initializeStoqCollectionButtons();

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
